import { Injectable } from '@angular/core';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { formatDate } from '@angular/common';

// Invoice header details. The header used to be one flattened image, which
// is why a company name / VAT change never showed up - keep these as text.
export const INVOICE_COMPANY = {
  name: 'Nuhome Living Ltd',
  address: 'Dobbies Lane, Marks Tey, Essex, CO6 1EP',
  vat: 'GB 525 9726 61',
};
export const INVOICE_LOGO =
  'data:image/png;base64,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';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService {
  constructor() {}

  getInvoice(order: any, isVatDiscounted: boolean, totalRefundedAmount: number = 0, refunds: any[] = []) {
    function getAddressByType(addrsType: string) {
      const foundAddrs = order.OrderAddresses.find(
        (addrs: any) => addrs.addressType === addrsType
      );


      if (addrsType === 'SHIPPING' && !foundAddrs) {
        const billingAdrs = order.OrderAddresses.find(
          (addrs: any) => addrs.addressType === 'BILLING'
        );
        return getAddressFormatted(billingAdrs);
      }

      return foundAddrs
        ? getAddressFormatted(foundAddrs)
        : `No ${addrsType.toLowerCase()} address given!`;
    }

    function getAddressFormatted(address: any) {
      let streetAddress = address.address1;
      if (address.address2) { streetAddress += `\n ${address.address2}`; }
      return `${address.firstName} ${address.lastName}
          ${address.companyName ? address.companyName : ''}
          ${streetAddress}
          ${address.city}
          ${address.country}
          ${address.postCode}`;
    }

    function getCustomerEmail() {
      const foundAddrs = order.OrderAddresses.find(
        (addrs: any) => addrs.addressType === 'BILLING'
      );
      return foundAddrs && foundAddrs.email ? foundAddrs.email : 'None found';
    }

    function getCustomerPhone() {
      const foundAddrs = order.OrderAddresses.find(
        (addrs: any) => addrs.addressType === 'BILLING'
      );
      return foundAddrs && foundAddrs.phoneNo
        ? foundAddrs.phoneNo
        : 'None found';
    }

    function getTotalWeight() {
      let totalWeight = 0;
      order.OrderItems.map((orderItem: any) => {
        totalWeight += orderItem.weight * orderItem.quantity;
      });
      return totalWeight.toFixed(2);
    }

    const dd: any = {
      pageMargins: [40, 90, 40, 40],
      header: [
        {
          margin: [40, 25, 40, 0],
          columns: [
            {
              width: 'auto',
              stack: [
                { image: INVOICE_LOGO, width: 130 },
                {
                  text: `VAT NUMBER : ${INVOICE_COMPANY.vat}`,
                  bold: true,
                  fontSize: 9,
                  margin: [3, 8, 0, 0],
                },
              ],
            },
            {
              width: '*',
              alignment: 'right',
              fontSize: 8,
              margin: [0, 8, 0, 0],
              text: `${INVOICE_COMPANY.name}, ${INVOICE_COMPANY.address}`,
            },
          ],
        },
      ],
      content: [
        {
          margin: [0, 0, 0, 0],
          text: `Invoice for order #${order.orderNo}`,
          style: 'header',
        },
        {
          margin: [0, 4, 0, 0],
          text: `Order Date: ${formatDate(
            order.orderDate,
            'dd-MM-yyyy',
            'en-US'
          )}`,
          style: 'subHeading',
        },
        order.paymentMethod !== ''
          ? {
              margin: [0, 8, 0, 0],
              text: `Payment Method: ${order.paymentMethod}`,
              style: 'payMethod',
            }
          : {},
        order.deliveryMethod === 'COLLECTION' && order.store
          ? {
              margin: [0, 8, 0, 0],
              text: `Collection Point: ${order.store}`,
              style: 'payMethod',
            }
          : {},
        (order.vatNumber
            ? {
                margin: [0, 8, 0, 0],
                text: `Vat number: ${order.vatNumber}`,
                style: 'payMethod',
              }
          : {}),
        {
          columns: [
            {
              width: '35%',
              text: 'Billing Address',
              style: 'subHeading2',
            },
            {
              width: '35%',
              text: 'Shipping Address',
              style: 'subHeading2',
            },
          ],
          margin: [0, 20, 0, 0],
          columnGap: 10,
        },
        {
          columns: [
            {
              width: '35%',
              text: getAddressByType('BILLING'),
              style: 'smallLightText',
            },
            {
              width: '35%',
              text: getAddressByType('SHIPPING'),
              style: 'smallLightText',
            },
          ],
          margin: [0, 5, 0, 0],
          columnGap: 10,
        },
        {
          margin: [0, 20, 0, 0],
          table: {
            widths: ['20%', '45%', '10%', '10%', '15%'],
            headerRows: 1,
            body: [
              [
                {
                  text: 'SKU',
                  style: 'tableHeader',
                  alignment: 'center',
                },
                {
                  text: 'Product',
                  style: 'tableHeader',
                  alignment: 'center',
                },
                {
                  text: 'Weight',
                  style: 'tableHeader',
                  alignment: 'center',
                },
                {
                  text: 'Quantity',
                  style: 'tableHeader',
                  alignment: 'center',
                },
                {
                  text: 'Price',
                  style: 'tableHeader',
                  alignment: 'center',
                },
              ],
              ...order.OrderItems.map((orderItem: any) => [
                {
                  text: orderItem.productSku,
                  style: 'tableContent',
                  fontSize: 9,
                },
                {
                  text: orderItem.productName,
                  style: 'tableContent',
                  fontSize: 9,
                },
                {
                  text: `${orderItem.weight * orderItem.quantity} Kg`,
                  style: 'tableContent',
                  alignment: 'center',
                },
                {
                  text: orderItem.quantity,
                  style: 'tableContent',
                  alignment: 'center',
                },
                {
                  text: `£${orderItem.subTotal}`,
                  style: 'tableContent',
                  alignment: 'center',
                },
              ]),
              [
                {
                  colSpan: 4,
                  alignment: 'right',
                  text: 'Total Weight:',
                  style: 'tableRowHeading',
                },
                {},
                {},
                {},
                {
                  alignment: 'right',
                  text: `${getTotalWeight()}Kg`,
                  style: 'tableContent',
                },
              ],
              [
                {
                  colSpan: 4,
                  alignment: 'right',
                  text: 'Subtotal:',
                  style: 'tableRowHeading',
                },
                {},
                {},
                {},
                {
                  alignment: 'right',
                  text: `£${order.orderAmount}`,
                  style: 'tableContent',
                },
              ],
              [
                {
                  colSpan: 4,
                  alignment: 'right',
                  text: 'Shipping:',
                  style: 'tableRowHeading',
                },
                {},
                {},
                {},
                {
                  alignment: 'right',
                  text: `£${order.shipCost}`,
                  style: 'tableContent',
                },
              ],
              ...(order.handleCharge && Number(order.handleCharge) > 0
                ? [
                    [
                      {
                        colSpan: 4,
                        alignment: 'right',
                        text: 'Handling Fee:',
                        style: 'tableRowHeading',
                      },
                      {},
                      {},
                      {},
                      {
                        alignment: 'right',
                        text: `£${order.handleCharge}`,
                        style: 'tableContent',
                      },
                    ],
                  ]
                : []),
              ...(order.discAmount && Number(order.discAmount) > 0
                ? [
                    [
                      {
                        colSpan: 4,
                        alignment: 'right',
                        text: isVatDiscounted ? 'VAT Amount:' : 'Discount Amount:',
                        style: 'tableRowHeading',
                      },
                      {},
                      {},
                      {},
                      {
                        alignment: 'right',
                        text: `-£${order.discAmount}`,
                        style: 'tableContent',
                      },
                    ],
                  ]
                : []),
              [
                {
                  colSpan: 4,
                  alignment: 'right',
                  text: 'Total',
                  style: 'tableRowHeading',
                },
                {},
                {},
                {},
                {
                  alignment: 'right',
                  text: `£${order.netAmount}${
                  !isVatDiscounted
                    ? ` (includes £${(order.orderAmount / 6).toFixed(2)} VAT)`
                    : ''
                }`,
                  style: 'tableContent',
                },
              ],
              ...(totalRefundedAmount > 0
                ? [
                    [
                      {
                        colSpan: 4,
                        alignment: 'right',
                        text: 'Net Balance',
                        style: 'tableRowHeading',
                      },
                      {},
                      {},
                      {},
                      {
                        alignment: 'right',
                        text: `£${(order.netAmount - totalRefundedAmount).toFixed(2)} (£${totalRefundedAmount.toFixed(2)} Refunded)`,
                        style: 'tableContent',
                      },
                    ],
                  ]
                : []),
              // [
              //   {
              //     colSpan: 4,
              //     alignment: 'right',
              //     text: 'Net Weight',
              //     style: 'tableRowHeading',
              //   },
              //   {},
              //   {},
              //   {},
              //   {
              //     alignment: 'right',
              //     text: `${getTotalWeight()} Kg`,
              //     style: 'tableContent',
              //   },
              // ],
            ],
          },
          layout: {
            fillColor: function (
              rowIndex: number,
              node: any,
              columnIndex: number
            ) {
              if (rowIndex % 2 !== 0) return '#f5f5f5';
              if (rowIndex === 0) return '#333333';
              return '';
            },
            paddingLeft: function (i: number) {
              return 8;
            },
            paddingRight: function (i: number, node: any) {
              return 8;
            },
            paddingTop: function (i: number, node: any) {
              return 3;
            },
            paddingBottom: function (i: number, node: any) {
              return 3;
            },
          },
        },
        {
          margin: [0, 20, 0, 0],
          text: 'Customer Details',
          style: 'subHeading2',
        },
        {
          margin: [0, 5, 0, 0],
          text: `Email: ${getCustomerEmail()}`,
          style: 'smallLightText',
        },
        {
          margin: [0, 2, 0, 0],
          text: `Phone: ${getCustomerPhone()}`,
          style: 'smallLightText',
        },
        (order.orderNotes && order.orderNotes !== ''
            ? {
                margin: [0, 2, 0, 0],
                text: `Customer Notes: ${order.orderNotes}`,
                style: 'smallLightText',
              }
            : {}),
        ...(refunds && refunds.length > 0
          ? [
              {
                margin: [0, 20, 0, 0],
                text: 'Refund Details',
                style: 'subHeading2',
              },
              {
                margin: [0, 5, 0, 0],
                ul: refunds.map((r: any) => ({
                  text: [
                    { text: `${new Date(r.refundDate).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}  `, bold: true },
                    { text: `£${parseFloat(r.amount).toFixed(2)}` , bold: true, color: '#c0392b' },
                    { text: `  —  ${r.reason || 'No reason provided'}` },
                  ],
                  style: 'smallLightText',
                })),
              },
            ]
          : []),
        {
          margin: [0, 20, 0, 0],
          text: 'If you have any questions regarding this document, please contact us on 01206 700 599 or support@nustone.co.uk.',
          style: 'normalText',
        },
      ],
      styles: {
        header: {
          fontSize: 16,
          bold: true,
        },
        subHeading: {
          fontSize: 14,
          color: '#9d9d9d',
        },
        subHeading2: {
          fontSize: 12,
          bold: true,
        },
        payMethod: {
          fontSize: 10,
          color: '#333333',
        },
        smallLightText: {
          fontSize: 10,
          color: '#51515c',
        },
        tableHeader: {
          color: '#f5f5f5',
          fontSize: 8,
          bold: true,
        },
        tableRowHeading: {
          color: '#333333',
          fontSize: 12,
          bold: true,
        },
        tableContent: {
          color: '#333333',
          fontSize: 11,
        },
        normalText: {
          fontSize: 12,
          color: '#333333',
        },
      },
    };

    pdfMake
      .createPdf(
        dd,
        {},
        {
          Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-Italic.ttf',
          },
          TimesNewRoman: {
            normal: 'Times-New-Roman-Regular.ttf',
            bold: 'Times-New-Roman-Bold.ttf',
            italics: 'Times-New-Roman-Italics.ttf',
            bolditalics: 'Times-New-Roman-Italics.ttf',
          },
        },
        pdfFonts.pdfMake.vfs
      )
      .open();
  }
}
